import React from "react";
import { DataTable, TableBody } from "@/components/ui/data-table";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import TransactionDataTableRow from "./TransactionDataTableRow";
import { Transaction } from "@/types/transaction";
import { useModal } from "@/contexts/ModalContext";

interface TransactionDataTableProps {
  transactions: Transaction[];
  loading: boolean;
  hasMore: boolean;
  loadMore: () => void;
}

const TransactionDataTable: React.FC<TransactionDataTableProps> = ({
  transactions,
  loading,
  hasMore,
  loadMore,
}) => {
  const { openModal } = useModal();

  const columns = [
    { id: "date", label: "Date", width: "12%", align: "left" as const },
    { id: "customer", label: "Customer", width: "18%", align: "left" as const },
    { id: "amount", label: "Amount", width: "12%", align: "left" as const },
    { id: "net_amount", label: "Net Amount", width: "12%", align: "left" as const },
    {
      id: "payment_method",
      label: "Method",
      width: "13%",
      align: "left" as const,
    },
    { id: "status", label: "Status", width: "11%", align: "left" as const },
    { id: "actions", label: "Source", width: "12%", align: "center" as const },
  ];

  const handleRowClick = (transaction: Transaction) => {
    openModal("transaction", transaction.id);
  };

  return (
    <div className="h-full">
      <DataTable className="h-full">
        <DataTable.Header columns={columns} />
        <TableBody className="relative">
          {transactions.map((transaction) => (
            <TransactionDataTableRow
              key={transaction.id}
              transaction={transaction}
              onClick={() => handleRowClick(transaction)}
            />
          ))}

          {hasMore ? (
            <tr className="border-t">
              <td colSpan={7} className="p-2 text-center">
                <Button
                  variant={null}
                  className="w-full py-2 rounded-md hover:text-primary"
                  onClick={loadMore}
                  disabled={loading}
                >
                  {loading ? (
                    "Loading..."
                  ) : (
                    <span className="flex items-center justify-center">
                      Load More <ChevronDown className="ml-2 h-4 w-4" />
                    </span>
                  )}
                </Button>
              </td>
            </tr>
          ) : (
            <tr className="border-t">
              <td colSpan={7} className="p-2 text-center text-muted-foreground hover:text-red-500">
                No more transactions to load.
              </td>
            </tr>
          )}
        </TableBody>
      </DataTable>
    </div>
  );
};

export default TransactionDataTable;